interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: "website" | "article";
  schema?: object;
}

export default function SEO({
  title = "911爆料网 | 911爆料吃瓜·911爆料网站·911吃瓜爆料 | 网红黑料实时追踪",
  description = "911爆料网提供全网最新网红黑料、明星八卦、社会奇闻，每日实时更新吃瓜大瓜。涵盖911爆料吃瓜、911爆料网站、911吃瓜爆料等热门入口，黑料视频一手掌握。",
  keywords = "911爆料网,911爆料吃瓜,911爆料网站,911吃瓜爆料,网红黑料,实时追踪,黑料视频,911爆料官网",
  canonicalUrl = "https://911baoliao.com",
  ogTitle = "911爆料网 | 网红黑料实时追踪",
  ogDescription = "911爆料网提供全网最新网红黑料、明星八卦、社会奇闻，每日实时更新吃瓜大瓜。",
  ogImage = "",
  ogType = "website",
  schema,
}: SEOProps) {
  const schemaScript = schema ? JSON.stringify(schema) : null;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      {schemaScript && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: schemaScript }}
        />
      )}
    </>
  );
}